define('plugin/tickets/TicketsPlugin',['require','lib/plugin/PluginAbstract'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');

    return PluginAbstract.extend({
        //TODO - for pwa
    });

});
